import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConstant } from "src/app/app.constant";

@Injectable()
export class MarksService {
    apiUrl: string;
    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    getAllByExamId(examId: number) {
        return this.httpClient.get(`${this.apiUrl}/marksList/` + examId).pipe(
            map((response: any) => {
                var data = response.data
                return {
                    data: data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>;
    }
    manageMarks(marks) {
        return this.httpClient.post(`${this.apiUrl}/insertMarkForOfflineExam`, marks).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public downloadExcelExamMark(dateRange){
        return this.httpClient.post(`${this.apiUrl}/downloadExcelExamMark`, dateRange,{ responseType: 'blob' })
    }
}
